var Transform = require('../common/transform.js'),
    cache = [ ];

var logger = new Transform();

logger.write = function(name, level, args) {
  cache.push([ name, level, args ]);
};

// utility functions
logger.get = function() { return cache; };
logger.empty = function() { cache = []; };

module.exports = logger;



//////////////////
// WEBPACK FOOTER
// ./node_modules/minilog/lib/web/array.js
// module id = v3fk
// module chunks = 0